import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import { PaginationModule, SpinnerModule } from '@spartacus/storefront';
import { GenAutoShipProductScrollComponent } from './auto-ship-products/auto-ship-product-scroll/auto-ship-product-scroll.component';
import { GenAutoShipProductsComponent } from './auto-ship-products/auto-ship-products.component';
import { GenAutoShipProductsService } from '../../services/auto-ship-products.service';
import { GenAutoShipShipmentScheduleService } from '../../services/auto-ship-shipment-schedule.service';
import { GenAutoShipShipmentScheduleComponent } from './auto-ship-shipment-schedule/auto-ship-shipment-schedule.component'
import { GenItemCounterComponent } from '../../shared/components/item-counter/item-counter.component';
import { GenAutoShipCartAdapter } from './core/connectors/auto-ship-cart.adapter';
import { GenAutoShipCartConnector } from './core/connectors/auto-ship-cart.connector';
import { GenOccAutoShipCartAdapter } from './occ/occ-auto-ship-cart.adapter';
import { GenAutoShipCartService } from '../../services/auto-ship-cart.service';
import { GenAutoShipShipmentFrequencyComponent } from './auto-ship-shipment-schedule/auto-ship-shipment-frequency/auto-ship-shipment-frequency.component';
import { GenAutoShipShipmentDateComponent } from './auto-ship-shipment-schedule/auto-ship-shipment-date/auto-ship-shipment-date.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    PaginationModule,
    RouterModule,
    SpinnerModule,
    GenAutoShipShipmentDateComponent,
    GenItemCounterComponent,
  ],
  declarations: [
    GenAutoShipProductsComponent,
    GenAutoShipProductScrollComponent,
    GenAutoShipShipmentScheduleComponent,
    GenAutoShipShipmentFrequencyComponent,
  ],
  exports: [GenAutoShipProductsComponent],
  providers: [
    GenAutoShipProductsService,
    GenAutoShipShipmentScheduleService,
    GenAutoShipCartConnector,
    GenAutoShipCartService,
    {
      provide: GenAutoShipCartAdapter,
      useClass: GenOccAutoShipCartAdapter,
    },
  ],
})
export class GenAutoShipProductsModule { }
